import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentSelectInputPlaceholder = () => /*#__PURE__*/_jsxs(Flex, {
  paddingInlineEnd: "200",
  inlineSize: "150px",
  blockSize: "24px",
  alignItems: "center",
  "data-test-id": "reassignment-select-placeholder",
  children: [/*#__PURE__*/_jsx(SkeletonCircle, {
    size: 24,
    marginInlineEnd: "100"
  }), /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    justifyContent: "space-around",
    inlineSize: "100%",
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "100%",
      blockSize: "0.75em"
    })
  })]
});
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';
export default ReassignmentSelectInputPlaceholder;